import { messagesEN } from './lib/intl/en-US';
import { messagesKO } from './lib/intl/ko';
import { messagesTH } from './lib/intl/th';
import { messagesZHHK } from './lib/intl/zh-HK';
import { messagesZHTW } from './lib/intl/zh';
import { messagesJA }from './lib/intl/ja';

import { assertValidLocale, Locale, Options } from '@sheerid/jslib';
import { RecursivePartial } from './lib/types/types';
import { getQueryParamsByName } from './lib/utils/browser';
export const programId = '607e03f20b018f691699f427';

export const LENOVO_URL = 'https://uat-www.lenovo.com';

let locale = getQueryParamsByName('language') || 'en-US';

try {
    assertValidLocale(locale as Locale);
  } catch (error) {
    locale = 'en-US';
}

export const defaultOptions: RecursivePartial<Options> = {
    locale: locale as Locale,
    restApi: {
        serviceUrl: 'https://services.sheerid.com',
    },
    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': messagesEN,
        'ko': messagesKO,
        'th': messagesTH,
        'zh-HK': messagesZHHK,
        'zh': messagesZHTW,
        'ja': messagesJA,
    },
    privacyPolicyUrl: 'https://www.sheerid.com/global-privacy-policy/',
};
